const { analyticsEventCenter, ANALYTICS_EVENTS } = require('../../events');
const { createEcommerceEventGA4 } = require('../models/ecommerceEventGA4');
const { createEcommerceEventItemsGA4 } = require('../models/ecommerceEventItemsGA4');
const pushEvent = require('../pushEvent');
const { buildItemListForProductTileClick } = require('../../helpers/itemListHelpers');
const positionUtils = require('../utils/positionUtils');

/* -------------------------------------------------------------------------- *\
 * PRODUCT TILE EVENTS                                                        *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  analyticsEventCenter.subscribe(ANALYTICS_EVENTS.productTileClicked, (payload) => {
    const tileList = buildItemListForProductTileClick(
      payload.location,
      payload.product.parentCategoryName,
    );

    pushEvent(
      createEcommerceEventGA4('select_item', createEcommerceEventItemsGA4([{
        ...payload.product,
        itemProps: {
          index: payload.position
            ? positionUtils.oneBasedPosition(payload.position)
            : undefined,
          item_list_id: tileList,
          searched_term: payload.searched_term || undefined,
        },
      }])),
    );
  });
}

module.exports = {
  subscribeToAnalyticsEvents,
};
